import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { environment } from "../../../environments/environment";
import { CONSTANTS } from "../constants/constants";
import { FormVoyagePnlFilter } from "./../models/earnings";
@Injectable({
  providedIn: "root",
})
export class EarningsService {
  constructor(private readonly http: HttpClient) {}

  headers = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
  };

  getLatestAveragePoolEarnings_V2(id: number, numOfMonth: number = 3) {
    const url =
      environment.BASE_API_URL +
      CONSTANTS.API.EARNING.LATEST_AVERAGE_POOL_EARNING_V2;
    return this.http.get<any>(url, {
      ...this.headers,
      params: { poolId: id.toString(), numOfMonth: numOfMonth.toString() },
    });
  }

  getLatestAveragePoolEarnings(id: number) {
    const url =
      environment.BASE_API_URL +
      CONSTANTS.API.EARNING.LATEST_AVERAGE_POOL_EARNING;
    return this.http.get<any>(url, {
      ...this.headers,
      params: { poolId: id.toString() },
    });
  }

  getPoolEarningsBreakdown(id: number) {
    const url =
      environment.BASE_API_URL +
      CONSTANTS.API.EARNING.GET_POOL_EARNINGS_BREAKDOWN;
    return this.http.get<any>(url, {
      ...this.headers,
      params: { poolId: id.toString() },
    });
  }

  getVoyagePnLs(data: {
    poolId: number;
    pageNumber: number;
    pageSize: number;
  }) {
    const url = environment.BASE_API_URL + CONSTANTS.API.EARNING.VOYAGE_PN_LS;
    return this.http.post<any>(url, data, this.headers);
  }

  public getVesselsV2(
    poolId: string,
    page: number = 1,
    pageSize: number = 50,
    option: { [key in string]: any } = {}
  ) {
    let url = environment.BASE_API_URL + CONSTANTS.API.VESSEL.V2.VESSELS;
    const params = {
      pools: poolId,
      page: page.toString(),
      pageSize: pageSize.toString(),
      vesselName: "",
      ...option,
    };
    return this.http.get<any>(url, { ...this.headers, params });
  }

  getVesselV2(poolId: number) {
    let url =
      environment.BASE_API_URL + CONSTANTS.API.EARNING.VOYAGE_PNL_VESSELS;
    const params = {
      poolId: poolId,
    };
    return this.http.get<any>(url, { ...this.headers, params });
  }

  getVoyagePnLsV2(data: FormVoyagePnlFilter) {
    const url =
      environment.BASE_API_URL + CONSTANTS.API.EARNING.VOYAGE_PN_LS_V2;
    return this.http.post<any>(url, data, this.headers);
  }
}
